import { useContext } from 'react'
import { MenuLayoutContext } from '../contexts/menu-layout-context'

export function useMenuLayout() {
    const { height, setHeight } = useContext(MenuLayoutContext)
    return { height, setHeight }
}
